import { render, staticRenderFns } from "./DialogComputeForMissingPayrollStatutories.vue?vue&type=template&id=b2cd2b38&scoped=true&"
import script from "./DialogComputeForMissingPayrollStatutories.vue?vue&type=script&lang=js&"
export * from "./DialogComputeForMissingPayrollStatutories.vue?vue&type=script&lang=js&"
import style0 from "./DialogComputeForMissingPayrollStatutories.vue?vue&type=style&index=0&id=b2cd2b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cd2b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VCardText,VContainer,VDialog,VIcon,VList,VListItem,VSpacer,VTooltip})
